var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootBeta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Beta",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n\n      .cls-2 {\n        fill: currentColor;\n      }\n\n      .cls-3 {\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.08,73.86c-2.34,0-4.23-1.89-4.23-4.23v-17.3c0-2.34,1.89-4.23,4.23-4.23s4.23,1.89,4.23,4.23v17.3c0,2.34-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.85,73.86c-2.34,0-4.23-1.89-4.23-4.23v-17.3c0-2.34,1.89-4.23,4.23-4.23s4.23,1.89,4.23,4.23v17.3c0,2.34-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.62,73.86c-2.34,0-4.23-1.89-4.23-4.23v-17.3c0-2.34,1.89-4.23,4.23-4.23s4.23,1.89,4.23,4.23v17.3c0,2.34-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.39,73.86c-2.34,0-4.23-1.89-4.23-4.23v-17.3c0-2.34,1.89-4.23,4.23-4.23s4.23,1.89,4.23,4.23v17.3c0,2.34-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.08,202.45c-2.34,0-4.23-1.89-4.23-4.23v-17.3c0-2.34,1.89-4.23,4.23-4.23s4.23,1.89,4.23,4.23v17.3c0,2.34-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.85,202.45c-2.34,0-4.23-1.89-4.23-4.23v-17.3c0-2.34,1.89-4.23,4.23-4.23s4.23,1.89,4.23,4.23v17.3c0,2.34-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152.62,202.45c-2.34,0-4.23-1.89-4.23-4.23v-17.3c0-2.34,1.89-4.23,4.23-4.23s4.23,1.89,4.23,4.23v17.3c0,2.34-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.39,202.45c-2.34,0-4.23-1.89-4.23-4.23v-17.3c0-2.34,1.89-4.23,4.23-4.23s4.23,1.89,4.23,4.23v17.3c0,2.34-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.68,96.85h-17.3c-2.34,0-4.23-1.89-4.23-4.23s1.89-4.23,4.23-4.23h17.3c2.34,0,4.23,1.89,4.23,4.23s-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.68,118.62h-17.3c-2.34,0-4.23-1.89-4.23-4.23s1.89-4.23,4.23-4.23h17.3c2.34,0,4.23,1.89,4.23,4.23s-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.68,162.16h-17.3c-2.34,0-4.23-1.89-4.23-4.23s1.89-4.23,4.23-4.23h17.3c2.34,0,4.23,1.89,4.23,4.23s-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.68,140.39h-17.3c-2.34,0-4.23-1.89-4.23-4.23s1.89-4.23,4.23-4.23h17.3c2.34,0,4.23,1.89,4.23,4.23s-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.09,96.85h-17.3c-2.34,0-4.23-1.89-4.23-4.23s1.89-4.23,4.23-4.23h17.3c2.34,0,4.23,1.89,4.23,4.23s-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.09,118.62h-17.3c-2.34,0-4.23-1.89-4.23-4.23s1.89-4.23,4.23-4.23h17.3c2.34,0,4.23,1.89,4.23,4.23s-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.09,162.16h-17.3c-2.34,0-4.23-1.89-4.23-4.23s1.89-4.23,4.23-4.23h17.3c2.34,0,4.23,1.89,4.23,4.23s-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.09,140.39h-17.3c-2.34,0-4.23-1.89-4.23-4.23s1.89-4.23,4.23-4.23h17.3c2.34,0,4.23,1.89,4.23,4.23s-1.89,4.23-4.23,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.91,185.15h-80.36c-10.86,0-19.69-8.83-19.69-19.69v-80.36c0-10.86,8.83-19.69,19.69-19.69h80.36c10.86,0,19.69,8.83,19.69,19.69v80.36c0,10.86-8.83,19.69-19.69,19.69ZM101.55,73.86c-6.19,0-11.23,5.04-11.23,11.23v80.36c0,6.19,5.04,11.23,11.23,11.23h80.36c6.19,0,11.23-5.04,11.23-11.23v-80.36c0-6.19-5.04-11.23-11.23-11.23h-80.36Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.22,
    y: 177.01,
    width: 161.02,
    height: 54.12,
    rx: 27.06,
    ry: 27.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.49,215.02v-23.58c0-2.19,1.23-3.43,3.43-3.43h12.61c5.8,0,8.77,3.7,8.77,7.77,0,3.84-2.38,6.4-5.25,6.99,3.24.5,5.85,3.66,5.85,7.49,0,4.57-3.06,8.22-8.86,8.22h-13.11c-2.19,0-3.43-1.23-3.43-3.47ZM104.11,200.26c2.19,0,3.56-1.42,3.56-3.38s-1.37-3.34-3.56-3.34h-8.13v6.72h8.13ZM104.34,212.97c2.47,0,3.93-1.42,3.93-3.61,0-1.92-1.37-3.56-3.93-3.56h-8.36v7.17h8.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.78,215.02v-23.58c0-2.19,1.23-3.43,3.43-3.43h15.63c1.55,0,2.83,1.23,2.83,2.83,0,1.51-1.28,2.74-2.83,2.74h-12.56v6.62h12.24c1.55,0,2.83,1.23,2.83,2.79s-1.28,2.79-2.83,2.79h-12.24v7.08h12.56c1.55,0,2.83,1.28,2.83,2.79s-1.28,2.83-2.83,2.83h-15.63c-2.19,0-3.43-1.23-3.43-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.45,215.57v-21.84h-6.35c-1.55,0-2.88-1.28-2.88-2.83s1.32-2.88,2.88-2.88h19.23c1.55,0,2.88,1.28,2.88,2.88s-1.32,2.83-2.88,2.83h-6.35v21.84c0,1.74-1.46,3.24-3.24,3.24s-3.29-1.51-3.29-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M195.99,215.53c0,1.83-1.51,3.29-3.34,3.29-1.42,0-2.65-.91-3.06-2.19l-1.23-3.56h-13.71l-1.23,3.56c-.41,1.28-1.69,2.19-3.11,2.19-1.83,0-3.29-1.46-3.29-3.29,0-.41.14-.82.23-1.14l8.91-23.03c.82-2.15,2.88-3.66,5.35-3.66s4.52,1.51,5.35,3.66l8.86,23.03c.14.32.28.73.28,1.14ZM186.35,207.44l-4.84-13.8-4.84,13.8h9.69Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootBeta);
export default __webpack_public_path__ + "static/media/boot_beta.568c303d0dd76fe78b3a0014c418c317.svg";
export { ForwardRef as ReactComponent };